import React, { useEffect, useRef, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { LoadingOverlay } from '@mantine/core';
// @ts-ignore
import styles from './index.module.scss';
import { notifications } from '@mantine/notifications';
import { useVipState, updateVipState } from '@shakkerai/pro-store';
import { useUserVipInfo, useUserIdentificationHooks, useCalcPointHooksV2 } from '@shakkerai/pro-commercial';
import { config } from '@shakkerai/config';
import { getUsertokenFromCookie } from '@shakkerai/util-cookie';
/**
 * Lib的会员弹窗，用于支持Pic
 * 2024年08月14日19:45:45
 * 不知为何，这里的iframe始终无法做到透明
 * @returns
 */
export const LibVipModal = () => {
  const proPurchaseModalVisible = useVipState('proPurchaseModalVisible');

  // 错误文案
  const errorCode = useVipState('currentErrorCode');
  const currentErrorMsg = useVipState('currentErrorMsg');

  const { userVipInfo } = useUserVipInfo();

  const { isEnoughForClac } = useCalcPointHooksV2();

  const { isSpecialYearUser } = useUserIdentificationHooks(userVipInfo);

  const closeModal = useCallback(() => {
    updateVipState({
      proPurchaseModalVisible: false,
      currentErrorMsg: '', // 关闭后，这个消息就不起作用了
    });
  }, []);

  const iframeRef = useRef();

  /**
   * 控制是否加载iframe
   */
  const { loadVipInfo } = useUserVipInfo();
  /**
   * 控制是否iframe已经完成了渲染
   */
  const [frameLoadFinished, setFrameLoadFinished] = useState(false);

  const timeoutHandler = useRef();

  useEffect(() => {
    if (proPurchaseModalVisible) {
      // 设置超时关闭
      timeoutHandler.current = setTimeout(() => {
        closeModal();
        notifications.show({
          title: '资源未能成功加载',
          message: '可能原因：登录态已失效，请退出登录后重新登录',
          color: '#FFBFC5',
        });
      }, 10000);

      const messageListener = async (event) => {
        try {
          if (!event.data) return;
          const parseResult = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
          if (parseResult.type === 'onPurchasesClose') {
            closeModal();
            setFrameLoadFinished(false);
          } else if (parseResult.type === 'onPurchasesFinish') {
            closeModal();
            setFrameLoadFinished(false);
            loadVipInfo();
          } else if (parseResult.type === 'onLoadPageFinished') {
            setFrameLoadFinished(true);

            // 取消超时动作
            if (timeoutHandler.current) {
              clearTimeout(timeoutHandler.current);
            }

            // IFrame加载完成后，打开会员弹窗
            iframeRef.current?.contentWindow.postMessage(
              JSON.stringify({
                type: 'show_purchase_dialog',
                data: {
                  // TODO: 根据状态码做文案映射
                  failurePrompt: currentErrorMsg ? [currentErrorMsg] : '',
                  isShowChargePop: isSpecialYearUser && !isEnoughForClac, // 专业高级版 算力不足时 弹充值弹窗
                },
              }),
              '*',
            );
          }
        } catch (error) {
          // 正常情况下忽略错误
        }
      };

      window.addEventListener('message', messageListener);

      return () => {
        window.removeEventListener('message', messageListener);
      };
    } else {
      return () => {};
    }
  }, [
    proPurchaseModalVisible,
    closeModal,
    errorCode,
    isSpecialYearUser,
    isEnoughForClac,
    currentErrorMsg,
    loadVipInfo,
  ]);

  const isProduction = config.name === 'online';
  const token = getUsertokenFromCookie();

  // @ts-nocheck
  // @eslint-disable-next-line，这里的地址需要在发布生产的时候改掉 本地环境 'http://localhost:3000/vip-model-page'
  const resourceUrl = isProduction ? 'https://liblib.art/vip-model-page' : 'https://www-test.liblib.art/vip-model-page';

  return (
    <div>
      {proPurchaseModalVisible &&
        createPortal(
          <div className="fixed top-0 left-0 right-0 bottom-0 z-[100] h-[100vh] w-[100vw] flex items-center justify-center">
            <LoadingOverlay visible={!frameLoadFinished} zIndex={1000} />

            <iframe
              src={`${resourceUrl}?token=${token}`}
              ref={iframeRef}
              onError={() => {
                closeModal();
              }}
              className={`w-full h-full ${frameLoadFinished ? 'block' : 'hidden'} ${styles.root}`}
            />
          </div>,
          document.body,
        )}
    </div>
  );
};
